import React from "react";
import { Button } from "@paljs/ui/Button";
import { InputGroup } from "@paljs/ui/Input";
import { EvaIcon } from "@paljs/ui";
import Col from "@paljs/ui/Col";
import { Card, CardBody } from "@paljs/ui/Card";
import styled, { css } from "styled-components";
import ReCAPTCHA from "react-google-recaptcha";
import { LoadingCard } from "../components/Loading/LoadingCard";
import TextSpan from "../components/Text/TextSpan";
import Fetch from "../components/Fetch";
import { toast } from "react-toastify";
import { useAuth } from "../components/Contexts/Auth";
import { useNavigate, Link } from "react-router-dom";

const Input = styled(InputGroup)`
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;

  input {
    padding-right: 40px;
  }
`;

const EyeButton = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: inherit;
  opacity: 0.6;

  &:hover {
    opacity: 1;
  }
`;

const Image = styled.img`
  height: 100px;
  margin-left: -10px;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const CenterRow = styled.div`
  display: flex;
  flex-direction: column;
  justifiy-content: center;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
`;

const Login = (props) => {
  const recaptchRef = React.useRef();

  const [reCaptcha, setReCaptcha] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);

  const { signIn, signOut, isLoading } = useAuth();
  let navigate = useNavigate();

  React.useEffect(() => {
    signOut();
  }, [signOut]);

  const onEnter = () => {
    if (!email?.trim()) {
      toast.warn("Informe o email");
      return;
    }
    if (!password?.trim()) {
      toast.warn("Informe a senha");
      return;
    }
    if (!reCaptcha) {
      toast.warn("Marque que você não é um robô");
      return;
    }
    signIn({
      email: email?.trim(),
      reCaptcha,
      password: password?.trim()
    },
      (user) => {
        if (user) {
          navigate("/os-panel");
        } else {
          if (recaptchRef.current) {
            recaptchRef.current.reset();
          }
          setReCaptcha("");
        }
      })
  };

  return (
    <>
      <div className="flex flex-col justify-center items-center" style={{ height: "100vh" }}>
        <Col breakPoint={{ md: 4, lg: 4, sm: 12 }} style={{ marginBottom: "300px" }}>
          <LoadingCard isLoading={isLoading}>
            <Card>
              <CardBody>
                <CenterRow>
                  <Image
                    src={'https://iotlog-images.s3.amazonaws.com/companies/99ea60e8-29d3-4bfa-b72e-f913ecd34fa0/1790688499498-ocp_cbo.png'}
                    alt="Logo_Fas"
                  />
                </CenterRow>
                <Input fullWidth>
                  <input
                    type="email"
                    placeholder="Email"
                    disabled={reCaptcha}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Input>
                {reCaptcha ? <Input fullWidth>
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Senha"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <EyeButton
                    type="button"
                    tabIndex={-1}
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                  >
                    <EvaIcon name={showPassword ? "eye-off-outline" : "eye-outline"} />
                  </EyeButton>
                </Input>
                  : <></>}

                {!reCaptcha && email?.includes('@') ? <CenterRow>
                  <Input fullWidth>
                    <ReCAPTCHA
                      onChange={(value) => setReCaptcha(value)}
                      size="normal"
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      ref={recaptchRef}
                    />
                  </Input>
                </CenterRow>
                  : <></>}

                {reCaptcha ? <>
                  <CenterRow center className="mt-4">
                    <Link to="/request-password">
                      <TextSpan apparence="s2">
                        Primeiro acesso / Esqueci minha senha
                      </TextSpan>
                    </Link>
                  </CenterRow>
                </> : <></>}

                <Button
                  status="Success"
                  type="button"
                  shape="SemiRound"
                  disabled={isLoading || !password || !email}
                  fullWidth
                  onClick={onEnter}
                >
                  Acessar
                </Button>
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30, marginBottom: 10 }}>
                  <TextSpan apparence="s2" hint>
                    2024 © IoTLog powered <a style={{ color: 'inherit', fontWeight: 'bold' }} href="https://www.bykonz.com" target="_blank">Bykonz</a>
                  </TextSpan>
                </div>
              </CardBody>
            </Card>
          </LoadingCard>
        </Col>
      </div>
    </>
  );
};
export default Login;
